import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PracticeSignup } from '../../models/practice-signup.interface';
import { from, switchMap } from 'rxjs';
import { PracticeSignupPdfService } from './practice-signup-pdf.service';

@Injectable({
  providedIn: 'root'
})
export class PracticeSignupService {

  constructor(
    private readonly http: HttpClient,
    private readonly pdfService: PracticeSignupPdfService,
  ) { }

  create(data: PracticeSignup): Observable<PracticeSignup> {
    const signupData: PracticeSignup = { ...data };
    delete signupData.consentPrivacy;
    delete signupData.consentUsage;

    const payload: PracticeSignup = JSON.parse(JSON.stringify(signupData));
    payload.createdAt = new Date().toISOString();
    return from(this.pdfService.generatePracticeSignupPdfBase64(payload)).pipe(
      switchMap((pdfBase64) => {
        payload.pdfBase64 = pdfBase64;
        return this.http.post<PracticeSignup>(environment.cva_url + API_ROUTES.PRACTISE_SIGNIP, payload);
      }),
    );
  }
}
